<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { useBlogStore } from '~/js/stores/blogs'

import { getGlobalTranslation } from '~/js/composables/translations'
import { useSetQueryParams } from '~/js/composables/query-parameters'

import { Category } from '~/js/interfaces/job'

import AlertNoResults from '~/vue/_molecules/alerts/AlertNoResults.vue'
import Filter from '~/vue/_organisms/filters/FilterBlogs.vue'
import TextH4 from '~/vue/_atoms/texts/TextH4.vue'
import Card from '~/vue/_molecules/cards/CardBlog.vue'
import Skeleton from '~/vue/_molecules/skeletons/SkeletonBlog.vue'
import ButtonSecondary from '~/vue/_atoms/buttons/ButtonSecondary.vue'

interface Type {
    type: string,
    title: string
}

interface Props {
    types: Array<Type>
    sectorCategories?: Array<Category> | null,
}

withDefaults(defineProps<Props>(), {
    sectorCategories: null,
})

const blogsStore = useBlogStore()
const { blogs, loading, pagination } = storeToRefs(blogsStore)

const onLoadMore = () => {
    blogsStore.fetch(false)
}

onMounted(async () => {
    const queryParameters = useSetQueryParams()

    blogsStore.setItemsPerPage(5)
    blogsStore.fetch(true, false, queryParameters)
})
</script>

<template>
    <section class="max-w-content mx-auto w-full container space-y-6 lg:space-y-11 pt-10 pb-20">

        <Filter 
            :types="types"
            :sectors="sectorCategories"
        />

        <div>
            <h2 class="mb-6">
                <TextH4>
                    {{ getGlobalTranslation('Resultaten') }}
                </TextH4>
            </h2>
            <div class="space-y-6">
                <Card 
                    v-if="blogs && !loading"
                    v-for="(post, i) in blogs.map(post => post.document)"
                    :card="post"
                />
                <Skeleton 
                    v-if="loading"
                    v-for="i in pagination.itemsPerPage"
                    :key="i"
                />

                <AlertNoResults v-if="blogs && blogs.length === 0 && !loading" />
            </div>
        </div>

        <ButtonSecondary
            v-if="!loading && (pagination.current < pagination.totalPages && pagination.current != pagination.totalPages)"
            utilities="mx-auto !block mt-4"
            type="button"
            :content="getGlobalTranslation('Toon meer resultaten')"
            @click="onLoadMore"
        />
    </section>
</template>